export enum TwoFactorAuthenticationFormFieldNames {
  two_fa_code = "two_fa_code",
  trust_browser = "trust_browser"
}

export type TwoFactorAuthenticationFormFieldValues = {
  [TwoFactorAuthenticationFormFieldNames.two_fa_code]: string
  [TwoFactorAuthenticationFormFieldNames.trust_browser]: boolean
}